// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1NZv2","inputWrap":"Table_inputWrap__2Irbg","col":"Table_col__3D_dV","bmiTooltip":"Table_bmiTooltip__3JBsB"};